<template>
  <div class="fof">
    <h1>{{ $t("404 vokabox not found!") }}</h1>
  </div>
</template>

<script>
export default {
  name: "FourOFour"
};
</script>

<style lang="scss">
.fof {
  height: calc(100vh - 300px) !important;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}
</style>
